// extracted by mini-css-extract-plugin
export default {"mainProductos":"Productos_mainProductos__c-yE9"};